import * as $$Array from "bs-platform/lib/es6/array.js";
import * as Curry from "bs-platform/lib/es6/curry.js";
import * as Bolt0_res$Bolt0 from "bolt0/./bolt0_res.bs.js";
import * as Bolt0_list$Bolt0 from "bolt0/./bolt0_list.bs.js";
import * as Table$SolvuuLang0 from "solvuu-lang0/./table.bs.js";
import * as Caml_builtin_exceptions from "bs-platform/lib/es6/caml_builtin_exceptions.js";

function Make(Record_param, Label) {
  var Table = Table$SolvuuLang0.Make(Record_param);
  var Private = {
    Record_param: Record_param,
    Label: Label,
    Table: Table
  };

  var columnNames = Curry._1(Label.named_exn, "columnNames");

  var labelColumnName = Curry._1(Label.named_exn, "labelColumnName");

  var barGrouping = Curry._1(Label.named_exn, "barGrouping");

  var layout = Curry._1(Label.named_exn, "layout");

  var data = Curry._1(Label.positional_exn, 1);

  var Label$1 = {
    columnNames: columnNames,
    labelColumnName: labelColumnName,
    barGrouping: barGrouping,
    layout: layout,
    data: data
  };

  var match = Curry._1(Record_param.R.of_alist,
  /* :: */
  [
  /* tuple */
  [columnNames,
  /* `List */
  [848054398,
  /* [] */
  0]],
  /* :: */
  [
  /* tuple */
  [labelColumnName,
  /* Null */
  870828711],
  /* :: */
  [
  /* tuple */
  [barGrouping,
  /* `String */
  [-976970511, "Grouped"]],
  /* :: */
  [
  /* tuple */
  [layout,
  /* `String */
  [-976970511, "Horizontal"]],
  /* :: */
  [
  /* tuple */
  [data,
  /* `List */
  [848054398,
  /* [] */
  0]],
  /* [] */
  0]]]]]);

  var arg;

  if (match[0] >= 17724) {
    arg = match[1];
  } else {
    throw [Caml_builtin_exceptions.assert_failure,
    /* tuple */
    ["bar_chart.ml", 133, 32]];
  }

  var Default = {
    arg: arg
  };
  var Const = {
    Label: Label$1,
    Default: Default
  };
  var $$Error = {};

  var to_record = function to_record(columnNames$1, labelColumnName$1, barGrouping$1, layout$1, data$1) {
    var columnNames$2 = Bolt0_list$Bolt0.map(function (x) {
      return (
        /* `String */
        [-976970511, x]
      );
    }, columnNames$1);
    var labelColumnName$2 = labelColumnName$1 !== undefined ?
    /* `Some */
    [925978388,
    /* `String */
    [-976970511, labelColumnName$1]] :
    /* Null */
    870828711;

    var match = Curry._1(Record_param.R.of_alist,
    /* :: */
    [
    /* tuple */
    [columnNames,
    /* `List */
    [848054398, columnNames$2]],
    /* :: */
    [
    /* tuple */
    [labelColumnName, labelColumnName$2],
    /* :: */
    [
    /* tuple */
    [barGrouping,
    /* `String */
    [-976970511, barGrouping$1]],
    /* :: */
    [
    /* tuple */
    [layout,
    /* `String */
    [-976970511, layout$1]],
    /* :: */
    [
    /* tuple */
    [data, data$1],
    /* [] */
    0]]]]]);

    if (match[0] >= 17724) {
      return match[1];
    } else {
      throw [Caml_builtin_exceptions.assert_failure,
      /* tuple */
      ["bar_chart.ml", 159, 28]];
    }
  };

  var columnNames$1 = Curry._2(Record_param.flag1, columnNames, Curry._1(Record_param.Flag.required, Curry._1(Record_param.Arg_type.list, Record_param.Arg_type.string)));

  var labelColumnName$1 = Curry._2(Record_param.flag1, labelColumnName, Curry._1(Record_param.Flag.required, Curry._1(Record_param.Arg_type.option, Record_param.Arg_type.string)));

  var barGrouping$1 = Curry._2(Record_param.flag1, barGrouping, Curry._1(Record_param.Flag.required, Curry._1(Record_param.Arg_type.$$enum,
  /* :: */
  ["Stacked",
  /* :: */
  ["Grouped",
  /* [] */
  0]])));

  var layout$1 = Curry._2(Record_param.flag1, layout, Curry._1(Record_param.Flag.required, Curry._1(Record_param.Arg_type.$$enum,
  /* :: */
  ["Vertical",
  /* :: */
  ["Horizontal",
  /* [] */
  0]])));

  var data$1 = Curry._2(Record_param.flag1, data, Curry._1(Record_param.Flag.required, Record_param.Arg_type.data));

  var of_record = function of_record(record, f) {
    var make = Curry.__5(f);

    var param = Curry._2(Record_param.Applicative_infix.$less$star$great, Curry._2(Record_param.Applicative_infix.$less$star$great, Curry._2(Record_param.Applicative_infix.$less$star$great, Curry._2(Record_param.Applicative_infix.$less$star$great, Curry._2(Record_param.Applicative_infix.$less$star$great, Curry._1(Record_param.$$return, make), Curry._1(Record_param.errs, columnNames$1)), Curry._1(Record_param.errs, labelColumnName$1)), Curry._1(Record_param.errs, barGrouping$1)), Curry._1(Record_param.errs, layout$1)), Curry._1(Record_param.errs, data$1));

    return Curry._2(Record_param.parse, record, param);
  };

  var dataTypeAvailable = function dataTypeAvailable(type_) {
    if (type_ !== 3654863) {
      return type_ === 365180284;
    } else {
      return true;
    }
  };

  var labelDataTypeAvailable = function labelDataTypeAvailable(type_) {
    if (typeof type_ === "number") {
      return type_ === -976970511;
    } else if (type_[0] !== 216537025) {
      return false;
    } else {
      return type_[1] === -976970511;
    }
  };

  var name = Curry._1(Label.positional_exn, 1);

  var sum = Curry._1(Label.positional_exn, 2);

  var Group = {
    name: name,
    sum: sum
  };

  var series = Curry._1(Label.named_exn, "series");

  var groups = Curry._1(Label.named_exn, "groups");

  var barGrouping$2 = Curry._1(Label.named_exn, "barGrouping");

  var layout$2 = Curry._1(Label.named_exn, "layout");

  var Label$2 = {
    Group: Group,
    series: series,
    groups: groups,
    barGrouping: barGrouping$2,
    layout: layout$2
  };
  var Const$1 = {
    Label: Label$2
  };
  var $$Error$1 = {};

  var numerical = Curry._1(Record_param.Arg_type.create, function (term) {
    if (typeof term === "number") {
      return (
        /* Invalid */
        144245463
      );
    } else {
      var variant = term[0];

      if (variant !== 3654863 && variant !== 365180284) {
        return (
          /* Invalid */
          144245463
        );
      } else {
        return (
          /* `Ok */
          [17724, term[1]]
        );
      }
    }
  });

  var optionalNumerical = Curry._1(Record_param.Arg_type.create, function (term) {
    if (typeof term === "number") {
      if (term !== 870828711) {
        return (
          /* Invalid */
          144245463
        );
      } else {
        return (
          /* `Ok */
          [17724, undefined]
        );
      }
    } else {
      var variant = term[0];

      if (variant !== 3654863 && variant !== 365180284) {
        if (variant !== 925978388) {
          return (
            /* Invalid */
            144245463
          );
        } else {
          var match = term[1];

          if (typeof match === "number") {
            return (
              /* Invalid */
              144245463
            );
          } else {
            var variant$1 = match[0];

            if (variant$1 !== 3654863 && variant$1 !== 365180284) {
              return (
                /* Invalid */
                144245463
              );
            } else {
              return (
                /* `Ok */
                [17724, match[1]]
              );
            }
          }
        }
      } else {
        return (
          /* `Ok */
          [17724, term[1]]
        );
      }
    }
  });

  var series$1 = Curry._1(Record_param.Arg_type.create, function (term) {
    if (typeof term === "number" || term[0] !== 848054398) {
      return (
        /* Invalid */
        144245463
      );
    } else {
      var match = term[1];

      if (match) {
        var match$1 = match[0];

        if (typeof match$1 === "number" || match$1[0] !== 847309489) {
          return (
            /* Invalid */
            144245463
          );
        } else {
          var keys = Curry._1(Record_param.R.keys, match$1[1]);

          var res = Bolt0_res$Bolt0.all(Bolt0_list$Bolt0.map(function (label) {
            var e = function (param) {
              return Bolt0_res$Bolt0.map(param, $$Array.of_list);
            }(Curry._3(Table.project_column, term, label, optionalNumerical));

            if (e[0] >= 106380200) {
              return e;
            } else {
              var name = Curry._1(Label.to_string, label);

              return (
                /* `Ok */
                [17724,
                /* tuple */
                [name, e[1]]]
              );
            }
          }, keys));

          if (res[0] >= 106380200) {
            return res[1];
          } else {
            return (
              /* `Ok */
              [17724, res[1]]
            );
          }
        }
      } else {
        return (
          /* `Ok */
          [17724,
          /* [] */
          0]
        );
      }
    }
  });

  var name$1 = Curry._2(Record_param.flag, name, Curry._1(Record_param.Flag.required, Record_param.Arg_type.string));

  var sum$1 = Curry._2(Record_param.flag, sum, Curry._1(Record_param.Flag.required, numerical));

  var make = function make(name, sum) {
    return (
      /* tuple */
      [name, sum]
    );
  };

  var group = Curry._2(Record_param.Applicative_infix.$less$star$great, Curry._2(Record_param.Applicative_infix.$less$star$great, Curry._1(Record_param.$$return, make), name$1), sum$1);

  var groups$1 = Curry._1(Record_param.Arg_type.create, function (term) {
    if (typeof term === "number" || term[0] !== 848054398) {
      return (
        /* Invalid */
        144245463
      );
    } else {
      var res = Bolt0_res$Bolt0.all(Bolt0_list$Bolt0.map(function (term) {
        if (typeof term === "number" || term[0] !== 847309489) {
          return (
            /* `Error */
            [106380200,
            /* Invalid */
            144245463]
          );
        } else {
          var match = Curry._2(Record_param.parse, term[1], group);

          if (match[0] >= 106380200) {
            return (
              /* `Error */
              [106380200,
              /* Invalid */
              144245463]
            );
          } else {
            return (
              /* `Ok */
              [17724, match[1]]
            );
          }
        }
      }, term[1]));

      if (res[0] >= 106380200) {
        return res[1];
      } else {
        return (
          /* `Ok */
          [17724, res[1]]
        );
      }
    }
  });

  var barGrouping$3 = Curry._1(Record_param.Arg_type.$$enum,
  /* :: */
  ["Grouped",
  /* :: */
  ["Stacked",
  /* [] */
  0]]);

  var layout$3 = Curry._1(Record_param.Arg_type.$$enum,
  /* :: */
  ["Vertical",
  /* :: */
  ["Horizontal",
  /* [] */
  0]]);

  var series$2 = Curry._2(Record_param.flag1, series, Curry._1(Record_param.Flag.required, series$1));

  var groups$2 = Curry._2(Record_param.flag1, groups, Curry._1(Record_param.Flag.required, groups$1));

  var barGrouping$4 = Curry._2(Record_param.flag1, barGrouping$2, Curry._1(Record_param.Flag.required, barGrouping$3));

  var layout$4 = Curry._2(Record_param.flag1, layout$2, Curry._1(Record_param.Flag.required, layout$3));

  var Param = {
    series: series$2,
    groups: groups$2,
    barGrouping: barGrouping$4,
    layout: layout$4
  };

  var of_record$1 = function of_record$1(record, f) {
    var make = Curry.__4(f);

    var param = Curry._2(Record_param.Applicative_infix.$less$star$great, Curry._2(Record_param.Applicative_infix.$less$star$great, Curry._2(Record_param.Applicative_infix.$less$star$great, Curry._2(Record_param.Applicative_infix.$less$star$great, Curry._1(Record_param.$$return, make), Curry._1(Record_param.errs, series$2)), Curry._1(Record_param.errs, groups$2)), Curry._1(Record_param.errs, barGrouping$4)), Curry._1(Record_param.errs, layout$4));

    return Curry._2(Record_param.parse, record, param);
  };

  return {
    Private: Private,
    Arg: {
      Const: Const,
      $$Error: $$Error,
      Param: {
        columnNames: columnNames$1,
        labelColumnName: labelColumnName$1,
        barGrouping: barGrouping$1,
        layout: layout$1,
        data: data$1
      },
      to_record: to_record,
      of_record: of_record,
      dataTypeAvailable: dataTypeAvailable,
      labelDataTypeAvailable: labelDataTypeAvailable
    },
    T: {
      Const: Const$1,
      $$Error: $$Error$1,
      Param: Param,
      of_record: of_record$1
    }
  };
}

export { Make };
/* No side effect */